<script>
	import Home from './Home2.svelte';
	import Form from './Form.svelte';

	let route = window.location.hash.replace('#','');
	function handleGo(event) {
		route = event.detail;
		window.location.hash = event.detail;
		window.scrollTo(0, 0);
	}
</script>

<div class='sans-serif'>
	{#if (route === '' || route === 'workwithtom')}
		<Home on:go={handleGo} />
	{:else if route === 'form'}
		<Form on:go={handleGo} />
	{/if}
</div>

<style>
	@media (min-width: 640px) {
		div {
			max-width: none;
		}
	}
</style>